(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colani-watch-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observers = new Set();
  const reveal = (element) => {
    element.classList.remove('cr-reveal-pending');
    element.classList.add('cr-reveal-visible');
  };
  const init = () => {
    document.querySelectorAll('.cr-home:not([data-cr-motion])').forEach((home) => {
      home.dataset.crMotion = 'ready';
      if (motion.matches || !('IntersectionObserver' in window) || document.documentElement.classList.contains('shopify-design-mode')) return;
      const groups = [
        home.querySelector('.cr-hero-copy'),
        home.querySelector('.cr-story'),
        home.querySelector('.cr-story > div'),
        home.querySelector('.cr-gallery'),
        home.querySelector('.cr-gallery-grid')
      ].filter(Boolean);
      const targets = new Set();
      groups.forEach((group) => {
        Array.from(group.children).filter((element) => element.matches('p,h1,h2,a,figure')).forEach((element,index) => {
          element.style.setProperty('--cr-delay', Math.min(index,3) * 90 + 'ms');
          targets.add(element);
        });
      });
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, {threshold:0.08,rootMargin:'0px 0px -24px 0px'});
      observers.add(observer);
      targets.forEach((element) => {
        if (element.getBoundingClientRect().top < window.innerHeight || element.contains(document.activeElement)) return;
        element.classList.add('cr-reveal-pending');
        observer.observe(element);
      });
      home.addEventListener('focusin', (event) => {
        const element = event.target.closest('.cr-reveal-pending');
        if (element) {reveal(element);observer.unobserve(element);}
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
  motion.addEventListener('change', () => {
    if (!motion.matches) return;
    document.querySelectorAll('.cr-home .cr-reveal-pending').forEach(reveal);
    observers.forEach((observer) => observer.disconnect());
    observers.clear();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
